import React, { useEffect, useContext } from 'react';
import Context from '../context/Context';
import SEO from '../components/seo';
import { Transition } from 'react-transition-group';
import ProductList from '../components/ProductList';

const TRANSITION_DURATION = 400;

const TRANSITION_STYLES = {
  default: {
    transition: `opacity ${TRANSITION_DURATION}ms ease`,
  },
  entering: {
    opacity: 0,
  },
  entered: {
    opacity: 1,
  },
  exiting: {
    opacity: 0,
  },
  exited: {
    opacity: 0,
  },
};

const Search = ({ pageContext, location }) => {
  const { seo = {} } = pageContext;
  const search = new URLSearchParams(location.search);
  const { searchStore, searchResults = [] } = useContext(Context);
  const searchTerm = search.get('q') && search.get('q').split(',');

  useEffect(() => {
    if (searchTerm) {
      searchStore(searchTerm);
    }
  }, []);

  return (
    <React.Fragment>
      <SEO
        metaTitle={searchTerm ? `Search results for ${searchTerm}` : 'Search'}
        metaDescription={seo?.metaDescription}
        metaKeywords={seo?.metaKeywords}
        openGraphTitle={
          searchTerm ? `Search results for ${searchTerm}` : 'Search'
        }
        openGraphDescription={seo?.openGraphDescription}
        openGraphImage={seo?.openGraphImage}
        twitterTitle={
          searchTerm ? `Search results for ${searchTerm}` : 'Search'
        }
        twitterDescription={seo?.twitterDescription}
        twitterImage={seo?.twitterImage}
        pathname={location.pathname}
      />
      <section className="search-hero p2 pt5--md bb--dark-brown">
        {searchTerm && (
          <React.Fragment>
            <div className="title df mb2 aib">
              <p className="mono--sm mono--md--md mr1 uppercase spotlight-index__label">
                Search:
              </p>
              <h1 className="serif--sm serif--lg--lg">{searchTerm}</h1>
            </div>
            <div className="title df mb2 aib">
              <p className="mono--sm mono--md--md mr1 uppercase spotlight-index__label">
                Results:
              </p>
              <p className="sans--sm sans--md--lg">
                {searchResults.length} Results
              </p>
            </div>
          </React.Fragment>
        )}
        {}
      </section>
      {searchResults.length > 0 && (
        <Transition
          in={searchTerm}
          mountOnEnter
          unmountOnExit
          appear
          timeout={TRANSITION_DURATION}
        >
          {status => (
            <section
              className="search-results"
              style={{
                ...TRANSITION_STYLES.default,
                ...TRANSITION_STYLES[status],
              }}
            >
              <ProductList products={searchResults} />
            </section>
          )}
        </Transition>
      )}
    </React.Fragment>
  );
};

export default Search;